import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const PercentComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(--icon-${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__percent"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6667 3.33325L3.33333 12.6666"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33334 6.00008C5.25381 6.00008 6 5.25389 6 4.33341C6 3.41294 5.25381 2.66675 4.33334 2.66675C3.41286 2.66675 2.66667 3.41294 2.66667 4.33341C2.66667 5.25389 3.41286 6.00008 4.33334 6.00008Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 13.3333C12.5871 13.3333 13.3333 12.5871 13.3333 11.6667C13.3333 10.7462 12.5871 10 11.6667 10C10.7462 10 10 10.7462 10 11.6667C10 12.5871 10.7462 13.3333 11.6667 13.3333Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Percent = withIcon(PercentComponent);
